var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("\n      You created the conversation "),_c('span',{staticClass:"text-success"},[_vm._v(_vm._s(_vm.event.data.name))]),_vm._v(".\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }